import React from "react";
import styles from "./PolicyPage.module.css";
import Nav from "../../../components/Nav/Nav";
import Footer from "../../../components/Footer/Footer";

const PolicyPage = () => {
  return (
    <div>
      <Nav />
      <div className={styles.body_4}>
        <section className={styles.section_6}>
          <div className={[styles.w_layout_blockcontainer, styles.container_14, styles.w_container].join(" ")}>
            <div className={styles.div_block_51}>
              <div>
                <div className={styles.text_block_35}>OUR</div>
                <h1 className={styles.heading_15}>POLICY</h1>
              </div>
              <div className={styles.div_block_52}>
                <div>
                  <h1 className={styles.heading_16}>Privacy Policy</h1>
                  <div className={styles.text_block_34}>
                    Last Updated: Nov 6th, 2024
                  </div>
                </div>
                <div className={styles.div_block_53}>
                  <div className={styles.text_block_30}>
                    This Privacy Policy explains how{" "}
                    <strong>Rayvo Smart Glasses</strong>,{" "}
                    <strong>Rayvo Glasses</strong>, <strong>we</strong>,{" "}
                    <strong>our</strong>, or <strong>us</strong> (hereinafter
                    referred to as “Rayvo Smart Glasses,” “Rayvo Glasses,” “we,”
                    “our,” or “us”) collects, uses, discloses, and safeguards
                    your information when you visit our website,{" "}
                    <a
                      href="http://www.rayvo.io"
                      target="_blank"
                      className={styles.link_6}
                      rel="noopener noreferrer"
                    >
                      www.rayvo.io
                    </a>
                    , and use our Rayvo Smart Glasses mobile application, as
                    well as any other media form, media channel, mobile website,
                    or mobile application related, linked, or otherwise
                    connected to our website and application (collectively, the
                    “Site”). By accessing or using our Site, you consent to our
                    collection, storage, and use of your information as
                    described in this Privacy Policy. If you do not agree to
                    this Privacy Policy, please do not access or use our Site.
                    <br />
                    <br />
                    By accessing or using our Site, you consent to our
                    collection, storage, and use of your information as
                    described in this Privacy Policy. If you do not agree to
                    this PrivacyPolicy, please do not access or use our Site.
                  </div>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    Information We Collect
                  </div>
                  <div className={styles.text_block_33}>
                    We may collect information about you in various ways. The
                    information we may collect on the Site includes:
                  </div>
                  <ul className={styles.list}>
                    <li className={styles.list_item_4}>
                      <strong>Personal Data</strong>: Identifiable information
                      such as your name, email address, and demographic details,
                      when you register on our Site or interact with our
                      features.
                    </li>
                    <li className={styles.list_item_5}>
                      <strong>Usage Data</strong>: Information regarding your
                      interactions with our Site, including device information,
                      IP address, browser type, access times, and pages visited.
                    </li>
                    <li className={styles.list_item_6}>
                      <strong>Location Information</strong>: If you use a mobile
                      device, we may collect location-based information.
                    </li>
                  </ul>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    How We Use Your Information
                  </div>
                  <div className={styles.text_block_33}>
                    We may use the information we collect about you for a range
                    of purposes, including:
                  </div>
                  <ul className={styles.list}>
                    <li className={styles.list_item_6}>
                      To facilitate account creation and the secure management
                      of your user profile.
                    </li>
                    <li className={styles.list_item_6}>
                      To communicate with you, respond to your inquiries, and
                      send you updates.
                    </li>
                    <li className={styles.list_item_6}>
                      To personalize your experience on the Site and offer
                      tailored content and product recommendations.
                    </li>
                    <li className={styles.list_item_6}>
                      To improve our services, enhance security, and develop new
                      features.
                    </li>
                  </ul>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    <strong>Sharing Your Information</strong>
                  </div>
                  <div className={styles.text_block_33}>
                    We may share your information in the following
                    circumstances:
                  </div>
                  <ul className={styles.list}>
                    <li className={styles.list_item_6}>
                      <strong>Service Providers</strong>: We may share your
                      information with trusted third-party vendors, service
                      providers, and consultants who work on our behalf.
                    </li>
                    <li className={styles.list_item_6}>
                      <strong>Legal Requirements</strong>: We may disclose your
                      information when required by law or to protect our rights,
                      property, or safety, as well as that of our users and the
                      public.
                    </li>
                    <li className={styles.list_item_6}>
                      <strong>Business Transfers</strong>: In case of a merger,
                      sale, or asset transfer, we may transfer your information
                      to the relevant third party.
                    </li>
                  </ul>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    <strong>Security of Your Information</strong>
                  </div>
                  <div className={styles.text_block_33}>
                    We take reasonable steps to secure the information you
                    provide to us from unauthorized access, misuse, or
                    disclosure. However, no data transmission over the Internet
                    or mobile networks can be guaranteed as completely secure.
                    While we strive to protect your information, we cannot
                    ensure or warrant the security of any information you
                    transmit to us.
                  </div>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    Your Privacy Rights
                  </div>
                  <div className={styles.text_block_33}>
                    Depending on your jurisdiction, you may have specific rights
                    regarding your personal data. These rights may include:
                  </div>
                  <ul className={styles.list}>
                    <li className={styles.list_item_6}>
                      The right to access, update, or delete the personal data
                      we hold about you.
                    </li>
                    <li className={styles.list_item_6}>
                      The right to restrict or object to certain processing of
                      your personal data.
                    </li>
                    <li className={styles.list_item_6}>
                      The right to receive a copy of your personal data in a
                      structured, machine-readable format.
                    </li>
                  </ul>
                  <div className={styles.text_block_33}>
                    To exercise any of these rights, please contact us at{" "}
                    <a href="mailto:contact@rayvo.io" className={styles.link_5}>
                      contact@rayvo.io
                    </a>
                    .
                  </div>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    <strong>Children’s Privacy</strong>
                  </div>
                  <div className={styles.text_block_33}>
                    Our Site and services are intended for individuals over the
                    age of 18. We do not knowingly collect or solicit personal
                    data from individuals under 18 years of age. If we discover
                    that we have collected personal data from a minor, we will
                    promptly delete that data.
                  </div>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    <strong>Updates to this Privacy Policy</strong>
                  </div>
                  <div className={styles.text_block_33}>
                    We may update this Privacy Policy from time to time to
                    reflect changes in our practices or for other operational,
                    legal, or regulatory reasons. We will alert you to any
                    changes by updating the “Last Updated” date of this Privacy
                    Policy. You waive the right to receive specific notice of
                    each such change.
                  </div>
                </div>
                <div className={styles.div_block_54}>
                  <div className={styles.text_block_32}>
                    <strong>Contact Us</strong>
                  </div>
                  <div className={styles.text_block_33}>
                    If you have any questions about this Privacy Policy or our
                    practices, please contact us at:{" "}
                    <a href="mailto:contact@rayvo.io" className={styles.link_5}>
                      contact@rayvo.io
                    </a>
                    .
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PolicyPage;
